import _get from "lodash/get";
import { PROGRESS } from "../modules/asyncHttpAction";
import * as session from "../modules/session/actions";
import * as notifications from "../modules/notifications/actions";

/**
 * Redux middleware that dispatches actions when an asyncHttpAction encounters a connection error or when the response has
 * a 401 or 500 status code.
 */
export default function handleAsyncHttpError(store) {
    return next => action => {
        const result = next(action);

        if (
            !_get(result, ["meta", "isApi"], false) ||
            _get(result, ["meta", "progress"]) !== PROGRESS.error
        ) {
            return result;
        }

        const statusCode = _get(result, ["error", "status"]);
        if (statusCode === 401) {
            store.dispatch(session.resetAuthToken());
        } else if (statusCode === 500 || statusCode === null) {
            store.dispatch(
                notifications.notifyError(
                    `A request to the Wevo servers failed`,
                    "exclamation-triangle"
                )
            );
        }

        return result;
    };
}



// WEBPACK FOOTER //
// ./src/store/asyncHttpError.js